var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 19C28.4404 19 29 19.5597 29 20.25V27.75C29 28.4404 28.4404 29 27.75 29H20.25C19.5597 29 19 28.4404 19 27.75V20.25C19 19.5596 19.5596 19 20.25 19H27.75ZM23.585 27.1221C23.3983 27.2901 23.1155 27.2932 22.9248 27.1299L21.4795 25.8906L20 27V27.75C20 27.8881 20.1119 28 20.25 28H27.75C27.8881 28 28 27.8881 28 27.75V27.2207L25.748 25.1738L23.585 27.1221ZM20.25 20C20.1119 20 20 20.1119 20 20.25V25.749L21.2002 24.8496C21.3876 24.7093 21.6474 24.7179 21.8252 24.8701L23.2422 26.085L25.416 24.1279C25.6068 23.9567 25.8961 23.9576 26.0859 24.1299L28 25.8691V20.25C28 20.1119 27.8881 20 27.75 20H20.25ZM22.5 20.75C23.4665 20.75 24.25 21.5335 24.25 22.5C24.25 23.4665 23.4665 24.25 22.5 24.25C21.5335 24.25 20.75 23.4665 20.75 22.5C20.75 21.5335 21.5335 20.75 22.5 20.75ZM22.5 21.75C22.0858 21.75 21.75 22.0858 21.75 22.5C21.75 22.9142 22.0858 23.25 22.5 23.25C22.9142 23.25 23.25 22.9142 23.25 22.5C23.25 22.0858 22.9142 21.75 22.5 21.75Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.093a55f250c91b1089422a02f9c1da70.svg";
export { ForwardRef as ReactComponent };